import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '@core/logging/logger.service';

@Injectable({ providedIn: 'root' })
export class AuthSessionNavigationService {
  private readonly router = inject(Router);
  private readonly logger = inject(LoggerService);

  redirectToLogin(): void {
    void this.router.navigate(['/login']).catch((error: unknown) => {
      this.logger.error('SessionExpiredInterceptor', error, { reason: 'redirect-to-login-failed' });
    });
  }
}
